/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

import { AuthenticationService } from './authentication.service';
import { BaseService } from "./base-service";

import { Action } from '../models/action';
import { RestService } from './rest-service';
import { Url_Base } from 'app/rest-constants';

@Injectable()
export class ActionService extends BaseService {
    
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private restService: RestService
        ) { super(router, authenticationService); }
    
    private getUrl(): string {
        return`${Url_Base}/actions/` 
    }
    
    getActionById(id: number): Promise<Action> {
        const callUrl = this.getUrl() + `${id}`;
        return this.restService.get<Action>(callUrl);
    }
    
    getAllActions(): Promise<Action[]> {
        const callUrl = this.getUrl();
        return this.restService.get<Action[]>(callUrl);
    }
    
    createAction(action: Action): Promise<Action> {
        const callUrl = this.getUrl();
        return this.restService.post<Action>(callUrl, action);
    }
    
    updateAction(action: Action): Promise<Action> {
        const callUrl = this.getUrl();
        return this.restService.put<Action>(callUrl, action);
    }   
    
    deleteAction(id: number): Promise<any> {
        const callUrl = this.getUrl() + `${id}`;
        return this.restService.delete(callUrl, id);
    }
    
    deleteActions(ids: number[]): Promise<any> {
        const callUrl = this.getUrl();
        return this.restService.delete(callUrl, ids);
    }

}
